import findIndex from 'lodash/findIndex';

export const cameras = (state = [], action) => {
  switch (action.type) {
    case 'CAMERA_ENTERED':
      const novaCamera = action.camera;
      return findIndex(state, {id: novaCamera.id}) >= 0 ? state : [...state, novaCamera];
    case 'CAMERA_EXITED':
      const index = findIndex(state, {id: action.camera.id});
      return [
        ...state.slice(0, index),
        ...state.slice(index + 1)
      ];
    case 'RESET_CAMERAS':
      return [];
    case 'CAMERA_MOVED':
    default: return state;
  }
};

export const cameraSelecionada = (state = {}, action) => {
  switch(action.type) {
    case 'SELECIONA_CAMERA':
      return action.camera;
    case 'RESET_CAMERAS':
      return {};
    default: return state;
  }
};

export const listeningCameras = (state = false, action) => {
  switch(action.type) {
    case 'TOGGLE_LISTENING_CAMERAS': return action.isListening;
    default: return state;
  }
};

export const videoUrl = (state = '', action) => {
  switch(action.type) {
    case 'VIDEO_URL_UPDATED': return action.videoUrl;
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/cameras.js